<div class="icon-text-align">
    <div class="circle" [ngClass]="{'inactive' : !active}">
        <mat-icon [svgIcon]="icon"></mat-icon>
    </div>
    <p>{{ label }}</p>
</div>
